import { render, staticRenderFns } from "./our-history.vue?vue&type=template&id=6f36a7a0&"
import script from "./our-history.vue?vue&type=script&lang=js&"
export * from "./our-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports